import React from 'react'
import {
ContainerFluid,HeadingText,Container,ParagraphText,ContainerFluidB,ContainerFluidC
} from './SectionAComponent.style';
function SectionAComponent() {
  return (
    <div>
      <ContainerFluid>
        <Container>
          <div className='row'>
            <div className='col s12 m12 l6 mt-3'>
              <HeadingText>
                Who we are
              </HeadingText>
              <ParagraphText>
                We are a fintech company that is committed to making halal savings 
                and investment easy, flexible, and accessible to everyone, globally.
              </ParagraphText>
            </div>
            <div class="col s12 m12 l7"></div>
          </div>
        </Container>
      </ContainerFluid>
      <ContainerFluidB>
        <Container>
        <div className='row'>
            <div className='col s12 m12 l6'>
              <br/>
              <HeadingText>
                Our Mission
              </HeadingText>
              <ParagraphText>
                Grant Muslims ease and accessiblity to a lifestyle that fulfills financial 
                and religious obligations.
              </ParagraphText>
              <br/>
              <HeadingText>
                Our Objectives
              </HeadingText>
              <ParagraphText>
                Be the go to platform for accessible halal savings and investments.
              </ParagraphText>
              <ParagraphText>
                Give Muslims the platform to achieve growth, success and profitability 
                  the right way. 
              </ParagraphText>
              <ParagraphText>
                Nurture a solution-oriented community that supports and advises the 
                  Muslim of today.
              </ParagraphText>
              <ParagraphText>
              Contribite and improve the lifestyle of the muslim community. 
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>
      <br/><br/>
      <ContainerFluidC className=''>
        <Container>
          <div className='row mt-100'>
            <div className='col s12 m12 l7'>
              <br/><br/><br/>
              <HeadingText>
                Contact Us
              </HeadingText>
              <ParagraphText>
                <b>Address:</b> 10, Deji Odunuga, Anthony,  Lagos, Nigeria
              </ParagraphText>
              <ParagraphText>
                <b>Phone number:</b>  +234 818 378 1220  
              </ParagraphText>
              <ParagraphText>
                <b>Email:</b>  hello@yalla.ng
              </ParagraphText>
              
            </div>
          </div>
        </Container>
      </ContainerFluidC>
    </div>
  )
}

export default SectionAComponent